import { Stack } from "@mui/material";

export default function BuyerInvoices() {
  return (
    <Stack
      alignItems="flex-start"
      sx={{
        mt: "100px",
        pl: "40px",
      }}
    >
      <h1>Buyer Invoices</h1>
    </Stack>
  );
}
